import {
	clientsPath,
	siteAppCustomCaptionsPath,
	siteAppMissingItemsPath,
	siteAppModelStatusesPath,
	siteAppModelTypesPath,
	siteAppOperationModesPath,
	siteAppFeedbackClassificationsPath,
	siteAppPausePath,
	siteAppSkippedTasksPath,
	siteAppStatusChangesPath,
	siteAppCMEditReasonsPath,
	siteAppStopsReasonsPath,
	siteAppTaskActionsPath,
	siteAppTaskSystemsPath,
	siteAppWorkbookFieldOrderPath,
	siteAppLubricantsPath,
	siteAppDefectTypesPath,
	siteAppFeedbackPrioritiesPath,
	siteAppUserRolesPath,
	siteAppDefectRiskRatingsPath,
	siteAppDefectStatusPath,
	siteAppDefectTemplatePath,
	siteAppDetailPath,
	siteAppPositionsPath,
	siteAppFeedbackStatuses,
	appPath,
	siteAppCustomIntegrationPath,
	siteAppTranslationGlossaryPath,
} from "helpers/routePaths";

import roles from "helpers/roles";
import i18n from "i18n";

/**
 * NOTE: This is currently a helper. In production, this data may come from either the API
 * or can be hard coded. Probably not approproate as a helper function
 */
const SiteApplicationNavigation = (
	clientId,
	siteId,
	appId,
	data,
	defaultCustom
) => {
	//application modal nav-dropdown states
	const showLubricants = data?.application?.showLubricants;
	const showSystem = data?.application?.showSystem;
	const showOperations = data?.application?.showOperatingMode;
	// Setting navigation links with correct application ID
	const links = `${appPath}${clientsPath}/${clientId}/sites/${siteId}/applications/${appId}/`;
	const taskDefList = [
		{
			title: data?.actionRequiredPluralCC || defaultCustom.actionRequiredPlural,
			link: links + siteAppTaskActionsPath,
		},
	];
	//add data only if its state is true
	if (showLubricants) {
		taskDefList.push({
			title: data?.lubricantPluralCC || defaultCustom.lubricantPlural,
			link: links + siteAppLubricantsPath,
		});
	}
	if (showSystem) {
		taskDefList.splice(1, 0, {
			title: data?.systemPluralCC || defaultCustom.systemPlural,
			link: links + siteAppTaskSystemsPath,
		});
	}
	if (showOperations) {
		taskDefList.splice(2, 0, {
			title: data?.operatingModePluralCC || defaultCustom.operatingModePlural,
			link: links + siteAppOperationModesPath,
		});
	}
	taskDefList.push({
		title: i18n.t("label.workbookOrder", {
			workbook: data?.workbookCC || defaultCustom?.workbook,
		}),
		link: links + siteAppWorkbookFieldOrderPath,
	});

	const navigation = [
		{
			name: i18n.t("title.details"),
			main: "Details",
			disableTo: [],
			dropdown: [
				{
					title: i18n.t("label.application"),
					link: links + siteAppDetailPath,
				},
				{
					title: i18n.t("title.siteTerminology"),
					link: links + siteAppCustomCaptionsPath,
				},
				{
					title: i18n.t("title.translationGlossary"),
					link: links + siteAppTranslationGlossaryPath,
				},
				{
					title: i18n.t("label.integrations"),
					link: links + siteAppCustomIntegrationPath,
				},
			],
			SiteApplicationNavigation,
		},
		{
			name: i18n.t("label.reasonDefinitions"),
			main: "Reason Definitions",
			disableTo: [roles.clientAdmin],
			dropdown: [
				{
					title:
						data?.application?.pauseReasonPluralCC ||
						defaultCustom.pauseReasonPlural,
					link: links + siteAppPausePath,
				},
				{
					title:
						data?.application?.stopReasonPluralCC ||
						defaultCustom.stopReasonPlural,
					link: links + siteAppStopsReasonsPath,
				},
				{
					title:
						data?.application?.skipReasonPluralCC ||
						defaultCustom.skipReasonPlural,
					link: links + siteAppSkippedTasksPath,
				},
				{
					title: i18n.t("label.missingPartOrTool", { part: data?.partCC || defaultCustom.part, tool: data?.toolPluralCC || defaultCustom.toolPlural }),
					link: links + siteAppMissingItemsPath,
				},
				{
					title: i18n.t("label.statusChanges"),
					link: links + siteAppStatusChangesPath,
				},
				{
					title: i18n.t("label.cmEditReasons"),
					link: links + siteAppCMEditReasonsPath,
				},
			],
		},
		{
			name: i18n.t("label.entityDefinitions", { entity: data?.modelCC || defaultCustom?.model }),
			main: "Model Definitions",
			disableTo: [roles.clientAdmin],
			dropdown: [
				{
					title: i18n.t("label.statuses"),
					link: links + siteAppModelStatusesPath,
				},
				{
					title: data?.modelTypePluralCC || defaultCustom.modelTypePlural,
					link: links + siteAppModelTypesPath,
				},
			],
		},
		{
			name: i18n.t("label.entityDefinitions", { entity: data?.taskCC || defaultCustom?.task }),
			main: "Task Definitions",
			disableTo: [roles.clientAdmin],
			dropdown: taskDefList,
		},
		{
			name: i18n.t("label.entityDefinitions", { entity: data?.userCC || defaultCustom?.user }),
			main: "User Definitions",
			disableTo: [roles.clientAdmin],
			dropdown: [
				{
					title: data?.positionPluralCC || defaultCustom.positionPlural,
					link: links + siteAppPositionsPath,
				},
				{
					title: data?.rolePluralCC || defaultCustom.rolePlural,
					link: links + siteAppUserRolesPath,
				},
			],
		},
		{
			name: i18n.t("label.entityDefinitions", { entity: data?.defectCC || defaultCustom?.defect }),
			main: "Defect Definitions",
			disableTo: [roles.clientAdmin],
			dropdown: [
				{
					title: data?.riskRatingPluralCC || defaultCustom.riskRatingPlural,
					link: links + siteAppDefectRiskRatingsPath,
				},
				{
					title: data?.defectStatusPluralCC || defaultCustom.defectStatusPlural,
					link: links + siteAppDefectStatusPath,
				},
				{
					title: data?.defectTypePluralCC || defaultCustom.defectTypePlural,
					link: links + siteAppDefectTypesPath,
				},
				{
					title: i18n.t("label.template"),
					link: links + siteAppDefectTemplatePath,
				},
			],
		},
		{
			name: i18n.t("label.entityDefinitions", { entity: data?.feedbackCC || defaultCustom.feedback }),
			main: "Feedback Definitions",
			disableTo: [roles.clientAdmin],
			dropdown: [
				{
					title:
						data?.classificationPluralCC || defaultCustom.classificationPlural,
					link: links + siteAppFeedbackClassificationsPath,
				},
				{
					title: data?.priorityPluralCC || defaultCustom.priorityPlural,
					link: links + siteAppFeedbackPrioritiesPath,
				},
				{
					title:
						data?.feedbackStatusPluralCC || defaultCustom.feedbackStatusPlural,
					link: links + siteAppFeedbackStatuses,
				},
			],
		},
	];

	return navigation;
};

export default SiteApplicationNavigation;
